function _of(x) {
  return [x];
}
module.exports = _of;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/src/internal/_of.js
// module id = 1295
// module chunks = 0